import { withTopbarProps } from '@jusbrasil/topbar'
import { withUserSession } from '@jusbrasil-web/shared-user-session'
import { GetServerSideProps } from 'next'
import { useRouter } from 'next/router'

import { AuthLayout } from '../../../components'

export interface PasswordResetPageProps {
  token?: string
}

export function PasswordResetPage({ token: tokenProp }: PasswordResetPageProps) {
  const router = useRouter()
  const token = tokenProp || (router.query.token as string)

  return (
    <AuthLayout>
      <div>Redefinir senha (token: {token})</div>
    </AuthLayout>
  )
}

const getServerSideProps: GetServerSideProps = async (ctx) => {
  return {
    props: {
      ...withTopbarProps(ctx),
      ...withUserSession(ctx),
      token: (ctx.params?.token as string | undefined) || null,
    },
  }
}

export const PasswordResetPageExports = {
  getServerSideProps,
}
